import { useState, useEffect } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { crossIcon } from "../../../assets/icons";
import { DRAWER_SIZE } from "../AppDrawers/drawers.constants";
import Alert, { selectAlert } from "../Alert";

const { FULL } = DRAWER_SIZE;

const Drawer = ({
  size,
  heading,
  subHeading,
  children,
  position,
  handleReset = () => {},
  handleClose = () => {},
  footer,
  selectedDrawer,
  allowScrollBar,
  alertErrorMessage,
}) => {
  const selectedAlert = useSelector(selectAlert);
  const [show, setShow] = useState(false);
  const [alertData, setAlertData] = useState(selectedAlert);

  useEffect(() => {
    if (selectedDrawer) setShow(true);
  }, [selectedDrawer]);

  useEffect(() => {
    if (show) {
      window.onpopstate = () => {
        window.onpopstate = () => {};
        handleClose();
      };
    }
  }, [show, handleClose]);

  useEffect(() => {
    setAlertData(selectedAlert);
  }, [selectedAlert]);

  const handleResetValues = () => {
    handleReset();
    handleClose();
  };

  return (
    <div>
      <div
        className={classNames({
          "fixed inset-0 bg-gray-900/75 backdrop-blur-md z-[70]": show,
        })}
        onClick={handleResetValues}
      />
      <div
        onClick={(e) => e.stopPropagation()}
        className={classNames(
          "fixed h-screen flex flex-col shadow-xl bg-gray-800 top-0 z-[100] transition-all duration-500",
          {
            "w-80 md:w-[400px]": size !== FULL,
            "w-full": size === FULL,
            "left-0": position === "left" && show,
            "d:-left-[400px] -left-80": position === "left" && !show,
            "right-0": position === "right" && show,
            "md:-right-[400px] -right-80": !show && size !== FULL,
            "-right-full": !show && size === FULL,
            "scrollbar overflow-auto": allowScrollBar,
          }
        )}
      >
        <div
          className={classNames("p-6 flex items-center", {
            "bg-gray-800 border-b border-gray-700": size === FULL,
            "bg-gray-900": size !== FULL,
          })}
        >
          <div>
            <h6
              className={classNames("text-base text-gray-50 font-bold", {
                "mb-2": subHeading,
              })}
            >
              {heading}
            </h6>
            <p
              className={classNames("", {
                "text-sm text-gray-500": size !== FULL,
                "text-sm text-gray-50": size === FULL,
              })}
            >
              {subHeading}
            </p>
          </div>
          <button
            type="button"
            className={classNames("ml-auto rounded-md ", {
              "bg-gray-900": size === FULL,
              "hover:bg-gray-800": size !== FULL,
            })}
            onClick={handleResetValues}
          >
            <img src={crossIcon} alt="close" className="w-6" />
          </button>
        </div>
        {alertData && (
          <div className="my-2 mx-7">
            <Alert
              type={alertData.type}
              message={alertErrorMessage || alertData.message}
              handleOnClose={setAlertData}
            />
          </div>
        )}
        {children}
        {footer}
      </div>
    </div>
  );
};

export default Drawer;
